// Copyright (c) 2020-2026 Life and Soft

import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { jwtDecode } from "jwt-decode";

import { logoutUser, setCurrentUser } from "../actions/authActions";
import setAuthToken from "./setAuthToken";

const PrivateRoute = ({ auth, children, accessRoles }) => {
  const location = useLocation();
  const token = localStorage.getItem("jwtToken");

  if (auth.isAuthenticated && token) {
    if (jwtDecode(token).exp < Date.now() / 1000) {
      logoutUser(jwtDecode(token).id);
    }

    if (accessRoles.includes(auth.user.role)) {
      setAuthToken(token);
      setCurrentUser(jwtDecode(token));

      return children;
    } else {
      return <Navigate to="/" replace />;
    }
  } else {
    let redirectUri =
      location.pathname === "/"
        ? "/login"
        : `/login?redirect=${location.pathname}`;
    return <Navigate to={redirectUri} replace />;
  }
};

PrivateRoute.propTypes = {
  auth: PropTypes.object.isRequired,
  logoutUser: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { logoutUser })(PrivateRoute);
